import { useSelector } from "react-redux";
import { selectIsSavingSettings, selectSetting } from "../app/settingsSlice";

/**
 * Custom hook to validate settings
 * @param {string} setting - The setting identifier to validate
 * @returns {boolean} - Returns true if setting is valid or not provided, false otherwise
 */
export const useSettingsValidation = setting => {
    const isSavingSetting = useSelector(selectIsSavingSettings);
    // Subscribed via useSelector (not a one-off getState() read) so this re-evaluates once
    // settingData finishes loading, instead of freezing at whatever it was on first render.
    const settingData = useSelector(selectSetting);

    if (!setting) return true;
    return !isSavingSetting && Boolean(settingData?.[setting]);
};
